<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<div class="page-container top-fix resize-index flex flex-col justify-start items-center min-h-[100vh]">
  <main class="content">
    <div class="white-card relative">
      <div class="login-content gap-y-[2.5em] flex flex-col justify-start items-center">
        <div class="entrance-back-button bold500" (click)="changePage('login')">
          <app-all-icons class="icon-size-1p5em" [iconNameAndStyling]="'back.svg'"></app-all-icons>
          Back
        </div>

        <div class="flex flex-col self-stretch gap-y-[0.625em] text-center">
          <div class="login-title leading-[1.2]">Reset password</div>
          <div class="font-2em">Enter your email to receive a link</div>
        </div>

        <!--send password form-->
        <form id="wf-form-Login"
          name="wf-form-Login"
          class="flex flex-col self-stretch gap-y-[1.25em]"
          [formGroup]="form">
          <app-input
            data-qa="Email"
            class="entrance-input"
            formControlName="email"
            [readonly]="false"
            [placeholder]="'Email'"
            [autofocus]="true"
            [additionalClass]="form.controls.email.errors?.email ? 'error' : ''"
          />

          <app-invisible-recaptcha
            *ngIf="showCaptchaV2"
            data-qa="recaptcha-v2"
            #captcha
            [siteKey]="siteV2Key"
            (resolved)="onCaptchaResolved($event)"
            (errored)="onCaptchaErrored($event)"
          />

          <app-button
            data-qa="reset-password-button"
            data-wait="Please wait..."
            class="entrance-button submit-button w-button bold500 clickable items-center"
            type="submit"
            [size]="'medium'"
            [disabled]="!form.controls.email.valid || (showCaptchaV2 && !captchaV2Token)"
            [ngClass]="!form.controls.email.valid || (showCaptchaV2 && !captchaV2Token) ? 'cursor-not-allowed opacity0p5' : ''"
            (buttonClick)="onSubmit()">
            Reset password
          </app-button>
        </form>

        <div class="flex flex-col items-center mobile-gap-0p625 gap-y-2">
          <div class="mobile-font-1 font-2em">Need help? Contact us at</div>
          <a class="link bold500 mobile-font-1 leading-[1.2] clickable" href="mailto:helpdesk@orcainc.com">{{ORCA_HELP_MAIL}}</a>
        </div>
      </div>
    </div>
  </main>
</div>
